import gql from 'graphql-tag';

export const AUDIENCE_TEMPLATE_WCA_LOOKALIKES_QUERY = gql`
  query AudienceTemplateWcaLookalikesQuery($first: Int, $after: String) {
    audienceTemplateWcaLookalikes(first: $first, after: $after) {
      edges {
        node {
          id
          name
          similarityThreshold
          urlGroups
          trafficRetentionDays
          lookalikeSeedSize
          lookalikeRatio
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
